import RetailInvoice, {
  generateIN_HA4_1PDF,
  generateBILL_HA4_1PDF,
} from "./halfa4/RetailInvoice";

import StandardReceipt, {
  generateIN_HA4_2PDF,
  generateBILL_HA4_2PDF,
} from "./halfa4/StandardReceipt";

import CompactInvoice, {
  generateIN_HA4_3PDF,
  generateBILL_HA4_3PDF,
} from "./halfa4/CompactInvoice";

import ClassicInvoice, {
  generateIN_HA4_4PDF,
  generateBILL_HA4_4PDF,
} from "./halfa4/ClassicInvoice";

import {
  Browser2InchInvoiceReceipt,
  Browser2InchBillReceipt,
  Browser3InchInvoiceReceipt,
  Browser3InchBillReceipt,
  Browser4InchInvoiceReceipt,
  Browser4InchBillReceipt,
} from "./terminal/ThermalM1InchBrowser";

import {
  Generate2InchBillReceipt,
  Generate2InchInvoiceReceipt,
  Generate3InchBillReceipt,
  Generate3InchInvoiceReceipt,
  Generate4InchBillReceipt,
  Generate4InchInvoiceReceipt,
} from "./terminal/ThermalM1InchGenerator";

import {
  Browser2InchBillReceiptM2,
  Browser2InchInvoiceReceiptM2,
  Browser3InchBillReceiptM2,
  Browser3InchInvoiceReceiptM2,
  Browser4InchBillReceiptM2,
  Browser4InchInvoiceReceiptM2,
} from "./terminal/ThermalM2InchBrowser";

import {
  Generate2InchBillReceiptM2,
  Generate2InchInvoiceReceiptM2,
  Generate3InchBillReceiptM2,
  Generate3InchInvoiceReceiptM2,
  Generate4InchBillReceiptM2,
  Generate4InchInvoiceReceiptM2,
} from "./terminal/ThermalM2InchGenerator";

import ProfessionalGSTInvoice, {
  generateInvProBillingPdf,
  generateInvProInvoicePdf,
} from "./a4/ProfessionalGSTInvoice";

import EssentialInvoice, {
  generateInvVessBillingPdf,
  generateInvVessInvoicePdf,
} from "./a4/EssentialInvoice";

import LegendExecutiveInvoice, { generateInvLexBillingPdf, generateInvLexInvoicePdf } from "./a4/LegendExecutiveInvoice";

import CommercialInvoice, {
  generateInvComBillingPdf,
  generateInvComInvoicePdf,
} from "./a4/CommercialInvoice";

import PrimeInvoice, { generateInvPrmBillingPdf, generateInvPrmInvoicePdf } from "./a4/PrimeInvoice";

import ServiceInvoice, { generateInvSevBillingPdf, generateInvSevInvoicePdf } from "./a4/ServiceInvoice";

import StructuredInvoice, {
  generateInvStrBillingPdf,
  generateInvStrInvoicePdf,
} from "./a4/StructuredInvoice";

import ReturnSaleInvoice, { generateInvReturn_HA4_4PDF, generateInvReturnInvoicePdf } from "./a4/ReturnSaleInvoice";
import PurchaseView, { generateInvPurchaseInvoicePdf } from "../components/pages/purchase/PurchaseView";
import PremiumInvoice, { generateBILL_HA4PRM_5PDF, generateIN_HA4PRM_5PDF } from "./halfa4/PremiumInvoice";

export const templateMap = {
  A4: {
    INVPRO: {
      preview: ProfessionalGSTInvoice,
      invoice: generateInvProInvoicePdf,
      bill: generateInvProBillingPdf,
    },
    INVOICEONE: {
      preview: ProfessionalGSTInvoice,
      invoice: generateInvProInvoicePdf,
      bill: generateInvProBillingPdf,
    },
    INVESS: {
      preview: EssentialInvoice,
      invoice: generateInvVessInvoicePdf,
      bill: generateInvVessBillingPdf,
    },
    INVOICETWO: {
      preview: EssentialInvoice,
      invoice: generateInvVessInvoicePdf,
      bill: generateInvVessBillingPdf,
    },
    INVSTR: {
      preview: StructuredInvoice,
      invoice: generateInvStrInvoicePdf,
      bill: generateInvStrBillingPdf,
    },
    INVOICEFOUR: {
      preview: StructuredInvoice,
      invoice: generateInvStrInvoicePdf,
      bill: generateInvStrBillingPdf,
    },

    INVCOM: {
      preview: CommercialInvoice,
      invoice: generateInvComInvoicePdf,
      bill: generateInvComBillingPdf,
    },
    INVOICEFIVE: {
      preview: CommercialInvoice,
      invoice: generateInvComInvoicePdf,
      bill: generateInvComBillingPdf,
    },

   INVSEV: {
      preview: ServiceInvoice,
      invoice: generateInvSevInvoicePdf,
      bill: generateInvSevBillingPdf,
    },
    INVOICESIX: {
      preview: ServiceInvoice,
      invoice: generateInvSevInvoicePdf,
      bill: generateInvSevBillingPdf,
    },

   INVLEX: {
      preview: LegendExecutiveInvoice,
      invoice: generateInvLexInvoicePdf,
      bill: generateInvLexBillingPdf,
    },
     INVPRM: {
      preview: PrimeInvoice,
      invoice: generateInvPrmInvoicePdf,
      bill: generateInvPrmBillingPdf,
    },
  
    RETURN: {
    preview: ReturnSaleInvoice,
    print:generateInvReturnInvoicePdf,    
    }, 
    
    PURCHASE: {
    preview: PurchaseView,
    print:generateInvPurchaseInvoicePdf,    
    } 
  },
  HALFA4: {
    HA4RET: {
      preview: RetailInvoice,
      invoice: generateIN_HA4_1PDF,
      bill: generateBILL_HA4_1PDF,
    },

    HA4SRT: {
      preview: StandardReceipt,
      invoice: generateIN_HA4_2PDF,
      bill: generateBILL_HA4_2PDF,
    },

    HA4CMP: {
      preview: CompactInvoice,
      invoice: generateIN_HA4_3PDF,
      bill: generateBILL_HA4_3PDF,
    },

    HA4CLS: {
      preview: ClassicInvoice,
      invoice: generateIN_HA4_4PDF,
      bill: generateBILL_HA4_4PDF,
    },
    
    HA4PRM:{
      preview: PremiumInvoice,
      invoice: generateIN_HA4PRM_5PDF,
      bill: generateBILL_HA4PRM_5PDF,
    },

    RETURN: {
    preview: ReturnSaleInvoice,
    print:generateInvReturn_HA4_4PDF    
    }   
  },

  TERMINAL: {
    // Thermal One (Basic)
    TMLBAS: {
      browser: {
        "2INCH": {
          invoice: Browser2InchInvoiceReceipt,
          bill: Browser2InchBillReceipt,
        },
        "3INCH": {
          invoice: Browser3InchInvoiceReceipt,
          bill: Browser3InchBillReceipt,
        },
        "4INCH": {
          invoice: Browser4InchInvoiceReceipt,
          bill: Browser4InchBillReceipt,
        },
      },

      generator: {
        "2INCH": {
          invoice: Generate2InchInvoiceReceipt,
          bill: Generate2InchBillReceipt,
        },
        "3INCH": {
          invoice: Generate3InchInvoiceReceipt,
          bill: Generate3InchBillReceipt,
        },
        "4INCH": {
          invoice: Generate4InchInvoiceReceipt,
          bill: Generate4InchBillReceipt,
        },
      },
    },

    // Thermal Two (Modern)
    TMLMOD: {
      browser: {
        "2INCH": {
          invoice: Browser2InchInvoiceReceiptM2,
          bill: Browser2InchBillReceiptM2,
        },
        "3INCH": {
          invoice: Browser3InchInvoiceReceiptM2,
          bill: Browser3InchBillReceiptM2,
        },
        "4INCH": {
          invoice: Browser4InchInvoiceReceiptM2,
          bill: Browser4InchBillReceiptM2,
        },
      },

      generator: {
        "2INCH": {
          invoice: Generate2InchInvoiceReceiptM2,
          bill: Generate2InchBillReceiptM2,
        },
        "3INCH": {
          invoice: Generate3InchInvoiceReceiptM2,
          bill: Generate3InchBillReceiptM2,
        },
        "4INCH": {
          invoice: Generate4InchInvoiceReceiptM2,
          bill: Generate4InchBillReceiptM2,
        },
      },
    },
  },
};
